import { Button, Tooltip } from "@fluentui/react-northstar";
import React from "react";

import { useUserInfo } from "../actions/useUserInfo";
import { startCheckoutTask } from "../utils/startTaskWrapper";
import useWindowDimensions from "../utils/useWindowDimensions";
import { PollyIcon } from "./PollyIcon";

type Props = {
  tooltip: string;
  className?: string;
};

export const DisabledUpgradeButton: React.FC<Props> = ({ tooltip, className }) => {
  const { loadUser } = useUserInfo();
  const { width } = useWindowDimensions();

  return (
    <>
      <Tooltip
        content={tooltip}
        trigger={
          <div style={{ display: "inline-block" }}>
            <Button
              className={className}
              content={
                <>
                  Upgrade <PollyIcon icon="pay-outline-icon" size="small" inheritColor />
                </>
              }
              onClick={() => {
                startCheckoutTask(false, "disabled-upgrade-btn", width, () => {
                  loadUser(true);
                });
              }}
            />
          </div>
        }
      ></Tooltip>
    </>
  );
};
